export default __webpack_public_path__ + "static/media/ethColored.ff6b170b.svg";